import React, { useContext, useEffect, useState } from "react";
import "./Wishlist.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardFooter, Col, Container, Row, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import SupermarketModal from "../Common_modal/Supermarket-modal/SupermarketModal";
import Product_Card from "../Common-Component/Product_Card/Product_Card";
import Common_Button from "../Common-Component/Common_Button/Common_Button";

import { ShimmerPostItem } from "react-shimmer-effects";
import { getWishlist, addWishlist } from "../../utils/apis/Wishlist/Wishlist";
import { AddToCart } from "../../utils/apis/addToCart/addToCart";
import { Context } from "../../utils/context";
import Product_Info_Card_2 from "../Common-Component/product_info_card_2/Product_Info_Card_2";
import Product_Info_List_View from "../shop/product_info_list_view/Product_Info_List_View";
import Top_Filter_Div from "../shop/top_filter_div/Top_Filter_Div";
library.add(fas);
const Wishlist = () => {

  
  const [modalShow, setModalShow] = React.useState(false);
  const [activeHearts, setActiveHearts] = useState([]);

  const handleHeartClick = (index) => {
    const updatedHearts = [...activeHearts];
    updatedHearts[index] = !updatedHearts[index];
    setActiveHearts(updatedHearts);
  };

  const [wishlistProducts, setWishlistProduct] = useState([]);

  const navigate = useNavigate();
  const {
    IMG_URL,
    shimmerLoader,
    setShimmerLoader,
    wishlistData,
    wishlistContext,
    selectedOption,
    setSelectedOption
  } = useContext(Context);

  const handleWishCart = async () => {
    await Promise.all(
      wishlistData?.map(async (value) => {
        await AddToCart({
          product_id: value?.product_id,
          variant_id: value?.variant_id,
        });
        await addWishlist(value?.product_id);
      }),
    );

    setModalShow(true);
    setTimeout(() => {
      setModalShow(false);
      navigate("/product-cart");
    }, 3000);
  };

  const getWishlist = async () => {
    setShimmerLoader(true);

    await setWishlistProduct(wishlistData);

    setShimmerLoader(false);
  };

  useEffect(() => {
    setWishlistProduct(wishlistData);
  }, [wishlistData]);
 
  return (
    <>
      <div className="wishlist">
        <div className="container">
          {wishlistProducts?.length > 0 ? (
            <>
              <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
                <Top_Filter_Div
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                />

                <div className="all_content_holder">
                  <div className="right_side_div">
                    <Tab.Content>
                      <Tab.Pane eventKey="Grid">
                        <div className="row">
                          {wishlistProducts?.map((product) => {
                            return (
                              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-5 custom_col">
                                <Product_Info_Card_2
                                  product={product?.product}
                                  showQty
                                  image={IMG_URL + product?.product?.image1}
                                  product_id={product?.product_id}
                                  variant_id={product?.variant_id}
                                  prodname={product?.product?.name}
                                  descn={product?.product?.short_description}
                                  selling_price={
                                    product?.product?.product_variants?.[0]
                                      ?.s_price
                                  }
                                  mrp={
                                    product?.product?.product_variants?.[0]?.mrp
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="List">
                        {wishlistProducts?.map((product) => {
                          return (
                            <Product_Info_List_View
                              product={product?.product}
                              showQty
                              image={IMG_URL + product?.product?.image1}
                              product_id={product?.product_id}
                              variant_id={product?.variant_id}
                              prodname={product?.product?.name}
                              descn={product?.product?.short_description}
                              selling_price={
                                product?.product?.product_variants?.[0]?.s_price
                              }
                              mrp={product?.product?.product_variants?.[0]?.mrp}
                            />
                          );
                        })}
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
        
            </>
          ) : (
            <section className="Empty_Cart">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-10">
                    <div className="shop-now-content">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/Cash_On_Delivery_Process/basket.png"
                          }
                          className="basket_img"
                        />
                      </div>
                      <div className="heading_holder mt-3">
                        <h5>Your Wishlist is Empty</h5>
                        <p> Explore more and shortlist some items</p>
                        <div className="main-btn-div">
                          <Link to={"/"}>
                            <Common_Button
                              className=" back-btn"
                              text=" Start Shopping"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      <SupermarketModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default Wishlist;
